/** Normalize a prices array from API (camelCase or PascalCase). */
export function normalizePrices(prices, fallbackPrice) {
    const list = Array.isArray(prices) ? prices : (prices ? [] : null);
    if (list && list.length > 0) {
        return list.map((p, index) => ({
            id: p.id ?? p.Id ?? null,
            name: p.name ?? p.Name ?? '',
            amount: p.amount ?? p.Amount ?? '',
            isDefault: p.isDefault ?? p.IsDefault ?? false,
            _key: p.id ?? p.Id ?? `new-${index}`,
        }));
    }
    if (fallbackPrice != null && fallbackPrice !== '') {
        return [{
            id: null,
            name: '',
            amount: fallbackPrice,
            isDefault: true,
            _key: 'default-0',
        }];
    }
    return [{ id: null, name: '', amount: '', isDefault: true, _key: 'default-0' }];
}

/** Default amount from a prices list. */
export function getDefaultPriceAmount(prices, fallbackPrice = null) {
    if (!Array.isArray(prices) || prices.length === 0) {
        return fallbackPrice != null && fallbackPrice !== '' ? Number(fallbackPrice) : null;
    }
    const def = prices.find((p) => p.isDefault ?? p.IsDefault);
    const chosen = def ?? prices[0];
    const amount = chosen?.amount ?? chosen?.Amount ?? fallbackPrice;
    return amount != null && amount !== '' ? Number(amount) : null;
}

/** Map UI prices to API DTO shape. */
export function pricesToApiDto(prices) {
    if (!Array.isArray(prices)) return null;
    const cleaned = prices
        .filter((p) => p != null && p.amount !== '' && p.amount != null && !Number.isNaN(Number(p.amount)))
        .map((p, index) => ({
            Id: p.id || null,
            Name: (p.name || '').trim() || null,
            Amount: Number(p.amount),
            IsDefault: !!p.isDefault,
            SortOrder: index,
        }));
    if (cleaned.length === 0) return [];
    if (!cleaned.some((p) => p.IsDefault)) {
        cleaned[0].IsDefault = true;
    }
    return cleaned;
}

/** True if the item has more than one selectable price. */
export function hasMultiplePrices(item) {
    if (!item) return false;
    const prices = item.prices ?? item.Prices;
    if (Array.isArray(prices) && prices.length > 1) return true;
    return false;
}

/** Resolve list of selectable prices for an item (for picker). */
export function getSelectablePrices(item) {
    if (!item) return [];
    const prices = item.prices ?? item.Prices;
    if (Array.isArray(prices) && prices.length > 0) {
        return prices.map((p) => ({
            id: p.id ?? p.Id ?? null,
            name: p.name ?? p.Name ?? '',
            amount: Number(p.amount ?? p.Amount ?? 0),
            isDefault: !!(p.isDefault ?? p.IsDefault),
        }));
    }
    if (item.price != null && item.price !== '') {
        return [{ id: null, name: '', amount: Number(item.price), isDefault: true }];
    }
    return [];
}

/**
 * Resolve the price to apply when selecting an item.
 * Returns { amount, needsPicker, prices }.
 */
export function resolveItemPriceSelection(item) {
    const prices = getSelectablePrices(item);
    if (prices.length === 0) {
        return { amount: null, needsPicker: false, prices };
    }
    if (prices.length === 1) {
        return { amount: prices[0].amount, needsPicker: false, prices };
    }
    return { amount: null, needsPicker: true, prices };
}
